export enum FilterProperty {
  ProductName = "productName",
  Location = "location",
  Category = "category",
  Condition = "condition",
  WarrantyTill = "warrantyEndDate",
  ServiceState = "serviceState",
  OrderNumber = "orderNumber",
  Sku = "sku",
}
